
import debounce from "lodash/debounce";
import { meetingAPI } from "@/api";
import { addSocketMessageListener } from "@/api/socketAPI";
import CommitmentsTabType from "@/constants/CommitmentsTabType";
import OutcomeSortType from "@/constants/OutcomeSortType";
import OutcomeType from "@/constants/OutcomeType";
import SocketMessageType from "@/constants/SocketMessageType";
import getPagedRequest from "@/helpers/pagerDuty";
import { store } from "@/store/store";

const DEFAULT_PAGE_SIZE = 25;

function getTargetKey( commitmentsTabType ) {
	let key = "meetingId";
	if ( commitmentsTabType === CommitmentsTabType.MEETING_SERIES ) {
		key = "meetingSeriesId";
	}
	if ( [ CommitmentsTabType.TEAM, CommitmentsTabType.ONE_ON_ONE, ].includes( commitmentsTabType ) ) {
		key = "teamId";
	}
	return key;
}

// NOTE: it's possible this method could live in the meetingAPI module. However,
// since it's so focused on the commitments store's needs, I'm starting w/it here first.
export const loadAllOutstandingOutcomes = getPagedRequest( {
	autoStart: false,
	limit: DEFAULT_PAGE_SIZE,
	request( { commitmentsTabType, id, offset, limit, outcomeStatus, } ) {
		return meetingAPI.fetchOutcomes( {
			[ getTargetKey( commitmentsTabType ) ]: id,
			offset,
			limit,
			outcomeStatus,
			outcomeType: OutcomeType.COMMITMENT,
			sortType: OutcomeSortType.OUTCOME_IMPORTANCE,
		} );
	},
	onResponse( commitments, { id, } ) {
		store.dispatch( "commitments/loadOutstandingCommitments", { id, commitments, isDone: DEFAULT_PAGE_SIZE !== commitments.length, } );
	},
} );

const commitmentsDispatcherMap = {};
const DEBOUNCE_INTERVAL = 5000;
export const initWebSocketListeners = () => {
	const commitmentsUpdateDispatcher = ( {
		outcomeId,
	} ) => {
		store.dispatch( "commitments/refreshCommitments", { outcomeId, } );
	};

	const updateCommitments = ( {
		body: {
			meetingId,
			outcomeId,
			personId,
		},
	} ) => {
		const { id, } = store.getters[ "userProfile/userProfile" ];
		if ( id !== personId ) {
			if ( !commitmentsDispatcherMap[ meetingId ] ) {
				commitmentsDispatcherMap[ meetingId ] = debounce( commitmentsUpdateDispatcher, DEBOUNCE_INTERVAL );
			}
			commitmentsDispatcherMap[ meetingId ]( {
				outcomeId,
			} );
		}
	};

	const removeCommitment = ( {
		body: {
			outcomeId,
			personId,
		},
	} ) => {
		const { id, } = store.getters[ "userProfile/userProfile" ];
		if ( id !== personId ) {
			store.dispatch( "commitments/removeCommitment", { outcomeId, } );
		}
	};

	addSocketMessageListener( SocketMessageType.OUTCOME_CREATED, updateCommitments );
	addSocketMessageListener( SocketMessageType.OUTCOME_UPDATED, updateCommitments );
	addSocketMessageListener( SocketMessageType.OUTCOME_DELETED, removeCommitment );
};




// WEBPACK FOOTER //
// ./src/store/modules/commitments/outcomeApiOrchestrator.js